<template>
    <div>
		<popup :is-set-styled="false" :is-btn-close="false" :show="popups.pdfViewer.show" :name="popups.pdfViewer.name" :add-class="'pdf-viewer__wrapper'">
            <pdf-viewer :files="files"></pdf-viewer>
        </popup>
    </div>
</template>


<script>
    import {mapState} from 'vuex';
    import Popup from '@/components/modal/Popup.vue';
    import StaffGroup from '@/components/modal/rules/StaffGroup.vue';
    import RemoveStaffGroupError from '@/components/modal/rules/RemoveStaffGroupError.vue';
    import KickUnReadAll from '@/components/modal/rules/KickUnReadAll.vue';
	import PdfViewer from '@/components/modal/rules/PdfViewer.vue';
	import CreateUser from '@/components/modal/rules/CreateUser.vue';
    import AddWorker from '@/components/modal/rules/AddWorker.vue';
    import Tooltip from '@/components/Tooltip.vue';
    import draggable from '@/helpers/vuedraggable.js';
    import DismissWorker from '@/components/modal/rules/DismissWorker.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import Tumbler from '@/components/Tumbler.vue';
	import AsideSticky from '@/components/AsideSticky.vue';

    export default {
        metaInfo() {
            return {
                title: 'ПОЛЬЗОВАТЕЛИ',
                titleTemplate: this.$store.state.options.titleTemplate
            }
        },
        name: "StaffDetail",
        components: {
            Popup,
            StaffGroup,
            RemoveStaffGroupError,
            Tooltip,
            draggable,
            AddWorker,
            DismissWorker,
            SubmitBtn,
            Tumbler,
            KickUnReadAll,
			AsideSticky,
			CreateUser,
			PdfViewer
        },
        data: function(){
            return {
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                userCurrent: state => state.users.user,
                editUser: state => state.rulesStaff.editUser,
            }),
            files(){
                return [
                    {link: process.env.VUE_APP_PATH_BACK + this.editUser.contract},
                    {link: process.env.VUE_APP_PATH_BACK + this.editUser.passport},
                    {link: process.env.VUE_APP_PATH_BACK + this.editUser.snils},
                    {link: process.env.VUE_APP_PATH_BACK + this.editUser.inn},
                ]
            }
        },
        methods:{

        },
        mounted() {
            this.$store.dispatch('rulesStaff/getUsersByID',{id:this.$route.params.id}).then(()=>{
                this.$store.dispatch('popups/open', {name: this.popups.pdfViewer.name});
            });
        },
    }
</script>
